import { observable } from "mobx";
import { Type } from "class-transformer";
import ExemptionDetailResponse from "./exemptionDetailResponse";
import VehicleRegisterVehicleDetailResponse from "./vehicleRegisterVehicleDetailResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ExemptionDetailGroupsResponse {
  @observable
  @Type(() => ExemptionDetailResponse)
  exemptionDetail!: ExemptionDetailResponse;

  @observable
  @Type(() => VehicleRegisterVehicleDetailResponse)
  vehicleRegisterVehicleDetail?: VehicleRegisterVehicleDetailResponse;
}
